import request from '@/utils/request'

/**
 * POST 方法 与 GET方法  区别
 *
 * post==> data: obj
 * get==>params: obj
 *
 */
 export function getCarModels(obj: any) {
  return request({
    url: '/car/models',
    method: 'get',
    params: obj,
  })
}
export function getSeriesInfo(obj: any) {
  return request({
    url: '/pc/items/seriesInfo',
    method: 'get',
    params: obj,
  })
}

